const _FEATURE_FLAGS_PERMANENT = [
  //
  // PERMANENT SWITCHES
  //
  'SWITCH_ws_notifications',

  // -- `LOCAL_DISABLE_*`
  //    Local-only; do NOT EVER save to split.io
  //    NOTE: To work without configuring in split.io, these need to be inverted
  //    flags (i.e. when the flag is ON the feature is OFF).  For that reason
  //    each switch here should be prefixed LOCAL_DISABLE_ to clearly indicate
  //    it's an inverted flag.
  'LOCAL_DISABLE_version_check',
] as const;

/**
 * @deprecated Reference the feature flag explicitly as a string literal instead.
 */
export enum EFeatureFlag {
  PUSH_STOCK_INVENTORY_LOCATION = 'red_DV-3409_push_stock_inventory_location',
  LOT_TRACKING = 'red_DV-1356_lot_tracking', // has backend
  PICK_AND_PACK = 'red_DV-1488_pick_and_pack', // has backend
  NEW_PURCHASE_ORDER_LIST_VIEW = 'red_feature_DV-1888_supplier_purchase_order_item_list',
  B2B_PORTAL_STORE_FRONTS = 'red_DV-2012_b2b_portal_store_fronts', // has backend
  CUSTOM_FIELDS = 'red_feature_DV-1909_custom_fields', // has backend
  INVOICE_EXPORT_TEMPLATE_CUSTOM_FIELDS = 'red_DV-2209_invoice_export_template_custom_fields', // has backend
  REMOVE_WOOCOMMERCE_FROM_CHANNEL_TYPES = 'red_DV-2284_remove_woocommerce_from_channel_types',
  CLIENT_PAYMENT_PROFILES = 'red_DV-2328_client_payment_profiles',
  UNIQUE_LOT_NUMBER_PER_SKU = 'red_DV-2352_unique_lotnumber_per_sku', // has backend
  SHOPIFY_OMS_INTEGRATION = 'red_DV-2392_shopify_oms_integration',
  TRACKSTAR_OMS_INTEGRATION = 'red_DV-2425_trackstar_oms_integration',
  ASSEMBLY_ORDER = 'red_DV-2218_assembly_orders',
  APPROVAL_MODULE = 'red_DV-2449_approval_module',
  APPLY_PRESETS_TO_SALES_ORDER_GRID = 'red_DV-2485_apply_presets_to_sales_order_grid',
  STOCKS_AG_GRID_REVAMP = 'red_DV-2489_stocks_ag_grid',
  EDI_INTEGRATION = 'red_DV-2272_edi_integration',
  SALES_ORDER_GRID_CUSTOM_FILTERS = 'red_DV-2488_sales_order_grid_custom_filters',
  PACKAGE_MANAGEMENT = 'red_DV-2507_package_management',
  ADD_RFQ_LEAD_TIME = 'red_DV-2643_add_rfq_lead_time', // has backend
  SUPPLIER_SOURCE_SKU = 'red_DV-2680_supplier_source_sku', // has backend
  FIFO_LANDED_COST_MULTIPLE_SHIPMENTS = 'red_DV-2659_fifo_landed_cost_multiple_shipments', // has backend
  REMOVE_PRODUCT_DEPARTMENT = 'red_CS-2756_remove_product_department',
  NEW_CREDIT_MEMO = 'red_DV-1920_new_credit_memo', // has backend
  PRODUCT_SUBSTITUTION = 'red_DV-2005_sku_substitutions', // has backend
  // == DO NOT ADD NEW FLAGS TO THIS ENUM. ==
}

export const FEATURE_FLAGS = [
  'utah-UTAH-363-accounting_dashboard',
  'red_CS-5115_sku_stocks_page_query_update',
  'utah-UTAH-356-so_grid_advanced_filters',
  'red_DV-3400_sales_channels_and_onhand_stocks_updates', // has backend
  'utah-UTAH-338-expose_requested_shipping_service_field',
  'red_DV-3389_inventory_reconciliation_report',
  'red_DV-3409_push_stock_inventory_location',
  'search_enable_indexing',
  'utah-UTAH-303-receipt_id_col_filter_and_sort',
  'red_DV-3362_fo_shipment_splits', // has backend
  'utah-UTAH-271-cost_layer_serverside_multisort',
  'UTAH-248-recount_incoming_with_shipments',
  'red_feature_DV_712_auto_save_po',
  'red_feature_DV-1062_apply_uom_on_adjustment_entries',
  'red_DV-2840_partial_fulfillment', // has backend
  'red_CS-3146_pickandpack_over_manual_updates', // has backend
  'utah_FR-577_bulk_update_requested_ship_date',
  'utah_FR-591_requested_ship_date_on_invoice',
  'utah_FR-577_make_sales_order_grid_requested_ship_date_cell_editable',
  'utah_DV-2872_overbuffer_to_pause_a_channel_product',
  'utah_UTAH-76_service_bell_widget',
  'red_DV-2964_automated_billing', // has backend
  'utah_FR-553_assembly_order_extra_costs',
  'red_DV-3027_Integration_Field_Mapping', // has backend
  'utah_FR-617_show_bom_notes_on_assembly_order_items',
  'utah_UTAH-126_tabs_in_s_o_grid_sidebar',
  'utah_UTAH-120_remove_channel_shippings',
  'red_DV-3094_multiple_warehouses_on_different_warehouse_groups', // has backend
  'red_DV-3138_template_management', // has backend
  'utah_UTAH-139_inbound_shipments_bulk_reconcile_new_transfer',
  'red_DV-3147_edi_810_invoice_sync', // has backend
  'utah_UTAH-154_helloscreen_by_upscope',
  'red_CS-3485_hide_unfulfilled_orders_total_numbers',
  'utah_UTAH-161_new_filters',
  'utah_UTAH-183_single_cost_layer_view',
  'utah-UTAH-210-single_cost_layer_edit',
  'red_CS-4036_override_cost_layer_unit_cost',
  'red_DV-3306_order_line_items',
  'utah-UTAH-219-hide_supplier_admin_field',
  'red_DV-3334_push_unpush_fulfillment_channel', // has backend
  'red_DV-3395_channel_types', // has backend
  ...Object.values(EFeatureFlag),
  ..._FEATURE_FLAGS_PERMANENT, // we want these at the bottom in the UI
] as const;

export type FeatureFlagValue =
  | EFeatureFlag
  | `${EFeatureFlag}`
  | (typeof FEATURE_FLAGS)[number];

export type FeatureHash = Record<FeatureFlagValue, boolean>;
